export const screens: { [key: string]: string } = {
    '/home': 'home',
    '/mobile': 'mobile_consumption',
    '/mobile/consumption': 'mobile_consumption_detail',
    '/mobile/extra-expense': 'mobile_extra_expense_detail',
    '/mobile/consumption/shared-data': 'shared_data_consumption_detail',
    '/mobile/bonus-available': 'bonuses_available',
    '/phone': 'phone_consumption',
    '/phone/consumption': 'phone_consumption_detail',
    '/phone/extra-expense': 'phone_extra_expense_detail',
    '/bonus-extra-details': 'detail_extra_bonuses',
    '/bonus-available/bonus-available-modal-extra-bonus': 'bonus_information',
    '/fiber': 'fiber',
    '/fiber/fiber-modal-check-speed': 'previous_fiber_test_velocity',
    '/fiber/fiber-test-velocity': 'fiber_test_velocity',
    '/enable-shared-data': 'share_data',
    '/devices': 'devices',
    '/device-detail': 'device_detail',
    '/fiber/fiber-modal-test-information': 'information_test',
    '/fiber/fiber-modal-test-interpretation': 'information_interpret_test',
    '/fiber/fiber-modal-slow-connection': 'information_slow_connection',
    '/fiber/fiber-modal-tips-to-improve-connection': 'information_improve_connection',
    '/configure-line': 'configure_line',
    '/configure-line/calldivert': 'call_forwarding',
    '/configure-line/blocked-number-specials': 'special_number_blocking',
    'configure-line/block-line': 'block_line',
    '/configure-line/roaming': 'roaming',
    '/bills': 'bills',
    '/bills/bill-detail': 'bill_detail',
    '/modal-debt-payment': 'debt_payment',
    '/modal-debt-payment/modal-rehabilitation-lines': 'rehabilitate_lines',
    '/modal-debt-payment/modal-bills-selection': 'select_bill_pay',
    '/explore': 'for_you',
    '/support': 'support',
    '/support/solve-incident': 'new_incident',
    '/support/incidents': 'your_incidents',
    '/support/incidents/incident-detail': 'incident_detail',
    '/profile': 'profile',
    '/profile/personal-data': 'personal_data',
    '/profile/personal-data/change': 'change_personal_data',
    '/profile/personal-data/add': 'add_personal_data',
    '/select-bank-account': 'select_bank_account',
    '/update-bank-account': 'update_bank_account',
    '/update-bank-account/feedback': 'update_bank_account_feedback',
    '/profile/change-password/update-password': 'update_password',
    '/profile/orders': 'orders',
    '/order-detail': 'order_detail',
    '/order-detail/modify-appointment': 'first_five_appointments_available',
    '/order-detail/modify-appointment-week': 'all_appointments_available',
    '/order-detail/modify-appointment/confirm': 'confirm_selected_appointment',
    '/order-detail/modify-appointment/feedback': 'feedback',
    '/order-detail/cancel/feedback': 'feedback',
    '/obd/daon': 'obd_to_DAON',
    '/profile/customer-agreement': 'obd_customer_agreement',
    '/obd/verify': 'obd_start_contacts_verification',
    '/obd/verify/contacts': 'obd_contacts_verification',
    '/obd/verify/otp': 'obd_verification_otp',
    '/escalation/otp': 'otp_choose_contact',
    '/escalation/otp/send': 'otp_contact_selected',
    '/escalation/otp/verify': 'verify_media_contact',
    '/configure-line/roaming/feedback/:context': 'feedback',
    '/mobile/bonus-available/feedback': 'feedback',
    '/enable-shared-data/enable-shared-data-message': 'feedback',
    '/modal-rehabilitation-lines/rehabilitation-lines-feedback': 'feedback',
    '/profile/customer-agreement/feedback': 'feedback',
    '/profile/personal-data/change/feedback': 'feedback',
    '/profile/personal-data/add/feedback': 'feedback',
    '/profile/personal-data/select-bankAccount/feedback': 'feedback',
    '/profile/change-password/update-password/feedback': 'feedback',
    '/support/incidents-feedback': 'feedback',
    '/escalation/otp/feedback': 'feedback',
    '/obd/verify/feedback': 'feedback',
    '/obd/verify/otp/feedback': 'feedback',
    '/error': 'feedback',
    '/escalation/contacts': 'escalation_contacts',
    '/escalation/contacts/verify': 'escalation_contacts_verify',
    '/update-personal-data': 'update_personal_data',
    '/contacts/verify': 'contacts_verify',
    '/contacts/validate': 'contacts_validate',
    '/feedback/contacts/validate': 'feedback',
};
